import { render, staticRenderFns } from "./view-serials-paging.vue?vue&type=template&id=a15b673a&"
import script from "./view-serials-paging.vue?vue&type=script&lang=ts&"
export * from "./view-serials-paging.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports